import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';

import BlueButton from '../../../buttons/BlueButton';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/process.home.actions';
import * as actionsvisibility from '../../../../actions/visibility.actions';
import * as actionslocals from '../../../../actions/locals.actions';

import { formatDate } from '../../../../functions/time';

import Menu from '../Menu';

class MenuValue extends React.Component {

    state = {
        value: '',
        from: formatDate(new Date()),
        localsInfo: []
    };

    constructor(props) {
        super(props);
        this.props.allLocalInfo();
    }

    static getDerivedStateFromProps(props, state) {
        const { localsInfo } = props;
        if (localsInfo !== state.localsInfo) {
            state.localsInfo = localsInfo;
            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleSearch = (event) => {
        const { local, from } = this.state;
        if (local) {
            this.props
                .loadVisibility(local, from)
                .then(() => this.props.history.push('/reports/controlpanel/result'))
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        }
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        const { local, from, localsInfo } = this.state;
        const { intl, info, visibility_is_loading, locals_is_loading } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '82') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        }
        else {
            return (
                <div className={'flex_full_row heigth100 bg_ice_blue'}>
                    <React.Fragment>
                        <Hidden xsDown>
                            <div className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'} >
                                <Menu {...this.props} active="controlpanel" />
                            </div>
                        </Hidden>
                        <div className={'flex_full_column padding_bottom_9 height100 center'}>
                            {(visibility_is_loading || locals_is_loading) && <Loading open opacity />}
                            <div className="width50 padding_borders_flat">
                                <div className="flex_full_row align_center margin_bottom_12">
                                    <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                        <InputLabel htmlFor="age-native-simple">
                                            {intl.formatMessage({ id: 'type_label_local' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={local}
                                            onChange={this.handleChange}
                                            inputProps={{ name: 'local', id: 'local-id' }}
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {localsInfo &&
                                                localsInfo
                                                    .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                                    .map((cat) => {
                                                        return (
                                                            <option key={randomstring()} value={cat.id}>
                                                                {cat.nombre}
                                                            </option>
                                                        );
                                                    })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="flex_full_row align_center margin_bottom_12">
                                    <TextField
                                        fullWidth
                                        name={'from'}
                                        id={'from-date'}
                                        label={intl.formatMessage({ id: 'date' })}
                                        type="date"
                                        value={from}
                                        onChange={this.handleChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </div>
                                <BlueButton noValid={!local} id="search" onClick={this.handleSearch} />
                            </div>
                        </div>
                    </React.Fragment>
                </div>
            );
        }
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired,
};


const mapStateToProps = (state) => {
    return {
        info: state.info,
        localsInfo: state.localsInfo,
        visibility_is_loading: state.visibility_is_loading,
        locals_is_loading: state.locals_is_loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        Object.assign({}, actions, actionsvisibility, actionslocals),
        dispatch,
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(MenuValue)));



// WEBPACK FOOTER //
// ./src/components/complex/reports/visibility/Menu.js